export default {
  'unavailable:btn': 'Вернуться на главную Kaspi.kz',
  'unavailable:title': 'Открытие счета Kaspi Gold для ребенка <br> будет доступно в {0}:00 '
}
